var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import { forEach, keys } from "lodash-es";
import { Vue, Component, Inject, Prop, Watch, Ref } from 'vue-property-decorator';
import { splitCompPath } from "../../../lib/utils";
import { INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import CompPathHistory from './CompPathHistory';
let CompPathBreadcrumb = class CompPathBreadcrumb extends Vue {
  constructor() {
    super(...arguments);
    /** 面包屑的行数 用来调整字号 */
    this.line = 1;
  }
  get partPaths() {
    const compPaths = ['', ...splitCompPath(this.designer.compPath).map(x => x.compPath)];
    return compPaths;
  }
  get style() {
    const style = {};
    if (this.line >= 2) {
      style.fontSize = '13px';
    }
    return style;
  }
  /** 更换compPath时动态计算组件的宽度决定是否换行 */
  partPathsChanged() {
    const changeLine = () => {
      const bread = this.$el;
      const child = this.$children;
      const breadLength = bread.getBoundingClientRect().width;
      const childLength = child.map(vnode => vnode.$el).filter(el => el.getBoundingClientRect).reduce((sum, el) => sum + el.getBoundingClientRect().width, 0);
      this.line = Math.ceil(childLength / breadLength);
    };
    // 从第二行缩回恰好撑满一整行时由于计算的是小字号宽度所以还要重新计算一遍是否真的能容在第一行里
    this.$nextTick(changeLine);
    setTimeout(changeLine);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "ref": "breadCrumb",
      "class": "ucd-compPathBreadcrumb",
      "style": this.style
    }, [h(CompPathHistory, {
      "attrs": {
        "paths": this.partPaths
      }
    }), this.partPaths.map((compPath, index) => h("a-tooltip", {
      "class": "ucd-compPathBreadcrumb-part",
      "key": compPath,
      "attrs": {
        "placement": "bottomLeft",
        "destroyTooltipOnHide": true
      }
    }, [h(CompNameTag, {
      "attrs": {
        "compPath": compPath,
        "defaultName": `组件#${index}`,
        "hideComponentId": this.designer.skeletonStyle.UcdToolbarBreadCrumbHideCompId,
        "showIfHaveEvents": true,
        "showIfHaveStyle": true
      }
    }), h(CompPopover, {
      "slot": "title",
      "attrs": {
        "compPath": compPath
      }
    })]))]);
  }
};
__decorate([Inject(INJECT_UICORE_DESIGNER)], CompPathBreadcrumb.prototype, "designer", void 0);
__decorate([Watch('partPaths', {
  deep: true,
  immediate: true
}), Watch('designer.skeletonStyle.UcdToolbarBreadCrumbHideCompId')], CompPathBreadcrumb.prototype, "partPathsChanged", null);
CompPathBreadcrumb = __decorate([Component({
  name: 'CompPathBreadcrumb'
})], CompPathBreadcrumb);
export default CompPathBreadcrumb;
let CompNameTag = class CompNameTag extends Vue {
  get layout() {
    return this.designer.getLayoutAtPath(this.compPath);
  }
  get name() {
    return this.designer.uc.getLayoutName(this.layout, {
      omitId: this.hideComponentId
    }) || this.defaultName || '未知组件';
  }
  get haveEvents() {
    var _this$layout;
    return !!keys((_this$layout = this.layout) === null || _this$layout === void 0 ? void 0 : _this$layout.events).length;
  }
  get haveConfiguredEventPanel() {
    var _this$layout2, _this$layout3;
    return this.haveEvents || !!((_this$layout2 = this.layout) !== null && _this$layout2 !== void 0 && _this$layout2.displayCondition) || !!((_this$layout3 = this.layout) !== null && _this$layout3 !== void 0 && _this$layout3.renderCondition);
  }
  get haveSpecStyle() {
    var _this$layout4;
    const styleKeys = Object.keys(((_this$layout4 = this.layout) === null || _this$layout4 === void 0 ? void 0 : _this$layout4.style) || {});
    const specKeys = 'width、height、minWidth、minHeight、maxWidth、maxHeight、flex、flexGrow';
    const haveSpec = styleKeys.some(key => specKeys.includes(key));
    return haveSpec;
  }
  handleMouseEnter() {
    this.designer.setHighlight(this.compPath, 'normal');
  }
  handleMouseLeave() {
    this.designer.setHighlight(this.compPath, false);
  }
  handleClick() {
    this.designer.compPath = this.compPath;
    this.designer.$refs.editZone.focus();
  }
  get isCurrent() {
    return this.designer.compPath === this.compPath || this.designer.compPath.startsWith(`${this.compPath}/`);
  }
  renderLayoutConfigHint() {
    const h = this.$createElement;
    const showList = [{
      condition: this.showIfHaveStyle && this.haveConfiguredEventPanel,
      icon: 'fa fa-bolt',
      title: '配置了事件',
      color: 'yellow'
    }, {
      condition: this.showIfHaveEvents && this.haveSpecStyle,
      icon: 'fa fa-asterisk',
      title: '配置了宽/高样式',
      color: '#4caf50'
    }].filter(item => item.condition);
    if (showList.length === 0) return null;
    return h("div", {
      "class": "ucd-compNameTag-iconList"
    }, [showList.map(item => h("div", {
      "class": "ucd-compNameTag-iconBox",
      "attrs": {
        "title": item.title
      }
    }, [h("i", {
      "class": item.icon,
      "style": {
        color: item === null || item === void 0 ? void 0 : item.color
      },
      "attrs": {
        "aria-hidden": "true"
      }
    })]))]);
  }
  render() {
    const h = arguments[0];
    return h("span", {
      "class": mergeClassName('ucd-compNameTag', this.isCurrent && 'isCurrent'),
      "attrs": {
        "title": this.compPath
      },
      "on": {
        "mouseenter": this.handleMouseEnter,
        "mouseleave": this.handleMouseLeave,
        "click": this.handleClick
      }
    }, [this.$slots.before, `${this.name}`, this.renderLayoutConfigHint(), this.withActions && !!this.compPath && h("div", {
      "class": "ucd-compNameTag-actions"
    }, [h("i", {
      "class": "fa fa-trash ucd-compNameTag-action",
      "attrs": {
        "title": "删除",
        "data-ucd-report-eid": "删除"
      },
      "on": {
        "click": () => {
          this.$nextTick(() => {
            this.designer.spliceComp(this.compPath);
          });
        }
      }
    }), this.$slots.after]), this.$slots.suffix]);
  }
};
__decorate([Prop(String)], CompNameTag.prototype, "compPath", void 0);
__decorate([Prop(String)], CompNameTag.prototype, "defaultName", void 0);
__decorate([Prop(Boolean)], CompNameTag.prototype, "withActions", void 0);
__decorate([Prop(Boolean)], CompNameTag.prototype, "hideComponentId", void 0);
__decorate([Prop(Boolean)], CompNameTag.prototype, "showIfHaveEvents", void 0);
__decorate([Prop(Boolean)], CompNameTag.prototype, "showIfHaveStyle", void 0);
__decorate([Inject(INJECT_UICORE_DESIGNER)], CompNameTag.prototype, "designer", void 0);
CompNameTag = __decorate([Component({
  name: 'CompNameTag'
})], CompNameTag);
export { CompNameTag };
let CompPopover = class CompPopover extends Vue {
  get layout() {
    return this.designer.getLayoutAtPath(this.compPath);
  }
  render() {
    const h = arguments[0];
    const {
      layout
    } = this;
    if (!layout) return null;
    const compPathPrefix = this.compPath;
    const result = [];
    forEach(layout.children, (child, index) => {
      result.push(h(CompNameTag, {
        "class": "ucd-toolbarPopMenu-item",
        "key": `default/${index}`,
        "attrs": {
          "compPath": `${compPathPrefix}/default/${index}`,
          "showIfHaveEvents": true,
          "showIfHaveStyle": true,
          "withActions": true
        }
      }));
    });
    forEach(layout.slots, (slotChildren, slotId) => {
      if (!slotChildren.length) return;
      result.push(h("hr", {
        "class": "ucd-toolbarPopMenu-rule"
      }), h("div", {
        "class": "ucd-toolbarPopMenu-item isDisabled"
      }, ["\u63D2\u69FD ", slotId]), ...slotChildren.map((child, index) => h(CompNameTag, {
        "class": "ucd-toolbarPopMenu-item",
        "key": `${slotId}/${index}`,
        "attrs": {
          "compPath": `${compPathPrefix}/${slotId}/${index}`,
          "withActions": true
        }
      })));
    });
    return h("div", {
      "class": "ucd-toolbarPopMenu ucd-compPopover",
      "ref": "menuDiv"
    }, [result]);
  }
  mounted() {
    // 如果出现滚动条就滚动到当前元素
    this.$nextTick(() => {
      const {
        menuDiv
      } = this;
      const current = menuDiv && [...menuDiv.children].find(x => x.matches('.isCurrent'));
      if (current && menuDiv && menuDiv.scrollHeight - 5 > menuDiv.offsetHeight) {
        const delta = current.offsetTop + current.offsetHeight - menuDiv.offsetHeight;
        if (delta > 0) menuDiv.scrollTo(0, delta);
      }
    });
  }
};
__decorate([Prop()], CompPopover.prototype, "compPath", void 0);
__decorate([Inject(INJECT_UICORE_DESIGNER)], CompPopover.prototype, "designer", void 0);
__decorate([Ref('menuDiv')], CompPopover.prototype, "menuDiv", void 0);
CompPopover = __decorate([Component({
  name: 'CompPopover'
})], CompPopover);
//# sourceMappingURL=CompPathBreadcrumb.js.map
